import Grid from '@mui/material/Grid';
import type { FunctionComponent, MouseEventHandler } from 'react';
import { useContext, useState } from 'react';

import { ApplicationContext } from '~/shared/context/context';
import type { BaseSkill } from '~/shared/data-contract/skill';

import { SkillChipWithDrawer } from '../../app/common/skills/SkillChipWithDrawer';
import { AdditionalItemsCountButton, ExpandOrCollapseDataButton } from './button/ExpandDataButton';

type RowProps = {
    readonly chipsOutlined?: boolean;
    readonly max: number;
    readonly skills: readonly BaseSkill[];
};

export const SkillsRow: FunctionComponent<RowProps> = (props) => {
    const { skills } = props;
    const { translate } = useContext(ApplicationContext);
    const [showAllSkills, setShowAllSkills] = useState(false);

    const onAdditionalSkillCounterClick: MouseEventHandler = (event) => {
        event.preventDefault();
        event.stopPropagation();

        setShowAllSkills(true);
    };

    const onCollapseSkillCounterClick: MouseEventHandler = (event) => {
        event.preventDefault();
        event.stopPropagation();

        setShowAllSkills(false);
    };

    const visibleSkills = showAllSkills ? skills : skills.slice(0, props.max);
    const additionalSkillsLength = skills.length - visibleSkills.length;

    return (
        <Grid aria-label="listbox" container={true} gap={1}>
            {visibleSkills.map((skill) => (
                <SkillChipWithDrawer
                    key={skill.id}
                    isSynced={skill.isSynced}
                    label={skill.title}
                    size="small"
                    skillId={skill.id}
                    type={skill.skillType}
                    variant={props.chipsOutlined === true ? 'outlined' : 'filled'}
                />
            ))}
            {additionalSkillsLength > 0 && (
                <AdditionalItemsCountButton number={additionalSkillsLength} onClick={onAdditionalSkillCounterClick} />
            )}
            {showAllSkills && (
                <ExpandOrCollapseDataButton
                    label={`- ${translate('common.show-less')}`}
                    onClick={onCollapseSkillCounterClick}
                />
            )}
        </Grid>
    );
};
